import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/b5a08d36-4e1b-4658-ac05-a4f9da84b1e7/images/e86ce27dd184d3832b122e8b9f1696977be8e76d9bcc7eba72d04ceec5d83aff.png";

const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[90vh] flex items-center overflow-hidden pt-20"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover"
          data-testid="hero-background"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-white/20" />
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 w-full">
        <div className="max-w-2xl py-24 sm:py-32">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#4A6670] mb-6 font-body section-fade" data-testid="hero-overline">
            InCred Global Asset Management
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-medium text-slate-900 font-heading leading-[1.1] section-fade delay-100" data-testid="hero-title">
            Investment Solutions<br />
            <span className="text-[#E87722]">Beyond Boundaries</span>
          </h1>
          <p className="mt-8 text-base sm:text-lg leading-relaxed text-slate-600 max-w-xl font-body section-fade delay-200" data-testid="hero-subtitle">
            Delivering differentiated investment strategies across equities and credit, 
            with a global perspective and disciplined approach to wealth creation.
          </p>
          <div className="mt-10 flex flex-wrap gap-4 section-fade delay-300">
            <Button
              data-testid="hero-cta-strategies"
              className="bg-[#E87722] hover:bg-[#D06A1E] text-white px-8 py-6 text-sm font-medium rounded-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
              onClick={() => document.querySelector('#strategies')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Explore Strategies
            </Button>
            <Button
              data-testid="hero-cta-about"
              variant="outline"
              className="border-[#4A6670] text-[#4A6670] hover:bg-[#4A6670] hover:text-white px-8 py-6 text-sm font-medium rounded-sm transition-all duration-300"
              onClick={() => document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Learn More
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ArrowDown className="h-5 w-5 text-[#4A6670] opacity-60" />
      </div>
    </section>
  );
};

export default Hero;
